<template>
    <div v-if="!item.hidden">
        <template v-if="hasOneShowingChild(item.menu_list,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
            <app-link v-if="onlyOneChild.name" :to="resolvePath(onlyOneChild.code, onlyOneChild.query)">
                 <el-menu-item :index="resolvePath(onlyOneChild.code)" :class="{'nest-menu-item': collapse}">
                    <i class="icon iconfont" :class='iconData[item.code]' style="margin-right:6px;font-size:18px;"></i>
                    <item :icon="onlyOneChild.icon" :title="onlyOneChild.name" />
                </el-menu-item>
            </app-link>
        </template>

        <el-submenu v-else ref="subMenu" :index="resolvePath(item.code)" popper-append-to-body>
            <template slot="title">
                <i class="icon iconfont" :class='iconData[item.code]' style="margin-right:6px;font-size:18px;"></i>
                <item v-if="item.name" :icon="item.icon" :title="item.name" />
            </template>
            <sidebar-item
                    v-for="(child, index) in item.menu_list"
                    :key="child.code + index"
                    :is-nest="true"
                    :item="child"
                    :collapse="collapse"
                    :base-path="resolvePath(child.code)"
                    class="nest-menu"
            />
        </el-submenu>
    </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
    name: 'SidebarItem',
    components: { Item, AppLink },
    mixins: [FixiOSBug],
    props: {
        // route object
        item: {
            type: Object,
            required: true
        },
        isNest: {
            type: Boolean,
            default: false
        },
        basePath: {
            type: String,
            default: ''
        },
        collapse: {
            type: Boolean,
            default: false
        }
    },
    data() {
        this.onlyOneChild = null
        return {
            iconData:{
                "indexPage":"icon-shouye",
                "systemManage":"icon-xitongguanlitubiao",
                "userManage":"icon-yonghuguanli",
                "newsManage":"icon-xinwenguanli",
                "resourceManage":"icon-ziyuanguanli1",
                "studyManage":"icon-xuexiguanli",
                "healthManage":"icon-jiankangguanli",
                "nutritionManage":"icon-caiyaoguanli",
                "taskCenter":"icon-renwuzhongxin",
                "surveyManage":"icon-wenjuantiaocha",
            }
        }
    },
    methods: {
        hasOneShowingChild(children = [], parent) {
            if (!children) {
                children = [];
            }
            const showingChildren = children.filter(item => {
                if (item.hidden) {
                    return false
                } else {
                    // Temp set(will be used if only has one showing child)
                    this.onlyOneChild = item
                    return true
                }
            })

            // When there is only one child router, the child router is displayed by default
            if (showingChildren.length === 10) {
                return true
            }

            // Show parent if there are no child router to display
            if (showingChildren.length === 0) {
                this.onlyOneChild = { ... parent, code: '', noShowingChildren: true }
                return true
            }

            return false
        },
        resolvePath(routePath, routeQuery) {
            if (isExternal(routePath)) {
                return routePath
            }
            if (isExternal(this.basePath)) {
                return this.basePath
            }
            if (routeQuery) {
                let query = JSON.parse(routeQuery);
                return { path: path.resolve(this.basePath, routePath), query: query }
            }
            return path.resolve(this.basePath, routePath)
        }
    }
}
</script>
<style lang="scss" scoped>
:deep(.nest-menu-item .el-tooltip) {
    padding: 0px !important;
    color: #03B355;
    background-color: white;
}
</style>
